module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Kit Get Set (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'juego de cables'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Kit Get Set (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'juego de cables'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Kit Get Set (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'juego de cables'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7749275320542',
        variantId: ['43223158915294', '43223158948062', '43223158980830'],
        capacity: 2,
        productName: '2kWh Power Kits',
        name: 'Kit Get Set (2kWh) ',
        discountPrice: 3898,
        originalPrice: 4898,
        unit: '€',
        includes: ['batería LFP de 2kWh x1', 'Power Hub', 'juego de cables'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7749275451614',
        variantId: ['43223159275742', '43223159341278', '43223159374046'],
        capacity: 4,
        productName: '4kWh Power Kits',
        name: 'Kit Get Set (4kWh) ',
        discountPrice: 5597,
        originalPrice: 7097,
        unit: '€',
        includes: ['batería LFP de 2kWh x2', 'Power Hub', 'juego de cables'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7749275484382',
        variantId: ['43223159570654', '43223159603422', '43223159636190'],
        capacity: 5,
        productName: '5kWh Power Kits',
        name: 'Kit Get Set (5kWh) ',
        discountPrice: 5998,
        originalPrice: 7498,
        unit: '€',
        includes: ['batería LFP de 5kWh x1', 'Power Hub', 'juego de cables'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7749275549918',
        variantId: ['43223159865566', '43223159898334', '43223159931102'],
        capacity: 10,
        productName: '10kWh Power Kits',
        name: 'Kit Get Set (10kWh) ',
        discountPrice: 9797,
        originalPrice: 12297,
        unit: '€',
        includes: ['batería LFP de 5kWh x2', 'Power Hub', 'juego de cables'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7749275615454',
        variantId: ['43223160226014', '43223160258782', '43223160291550'],
        capacity: 15,
        productName: '15kWh Power Kits',
        name: 'Kit Get Set (15kWh) ',
        discountPrice: 13596,
        originalPrice: 17096,
        unit: '€',
        includes: ['batería LFP de 5kWh x3', 'Power Hub', 'juego de cables'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: 'Controla y visualiza tu uso de la energía.',
      discountPrice: 500,
      originalPrice: 570,
      unit: '€',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'Panel de distribución inteligente CA/CC',
        desc: 'Con 12 posiciones de CC protegidas por fusible y 6 posiciones de CA protegidas por AFCI, puedes administrar la distribución de la energía alrededor de tu autocaravana o minicasa. Controla hasta 6 posiciones de CC desde la aplicación o consola EcoFlow.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Panel de distribución inteligente CA/CC',
          desc: 'Con 12 posiciones de CC protegidas por fusible y 6 posiciones de CA protegidas por AFCI, puedes administrar la distribución de la energía alrededor de tu autocaravana o minicasa. Controla hasta 6 posiciones de CC desde la aplicación o consola EcoFlow.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'Entrada principal de CA',
            value: '16A máx., 230V, 3600W'
          }, {
            key: 'Entrada principal de CC',
            value: '70A máx.'
          }, {
            key: 'Salida de CA',
            value: '6 posiciones de CA, 10A máx. cada una'
          }, {
            key: 'Salida de CC',
            value: '12 posiciones de CC protegidas por fusible (6 posiciones controlables a través de la consola y la aplicación del Power Kit)'
          }, {
            key: 'Temperatura de funcionamiento',
            value: 'de - 25 ºC a 60 ºC'
          }, {
            key: 'Tamaño',
            value: '210 x 354 x 98 mm (Alto x Ancho x Profundidad)'
          }, {
            key: 'Peso neto',
            value: '2,6 kg'
          }, {
            key: 'Nivel de protección',
            value: 'IP21'
          }, {
            key: 'Pruebas y certificaciones',
            value: 'CE, UL, FCC, EMC Clase B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'Correa de Montaje',
        desc: 'Monta las baterías de manera segura.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: 'Añade energía, controla tu sistema y supervisa el uso de la energía.',
      discountPrice: 800,
      originalPrice: 900,
      unit: '€',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'Panel de distribución inteligente CA/CC',
        desc: 'Con 12 posiciones de CC protegidas por fusible y 6 posiciones de CA protegidas por AFCI, puedes administrar la distribución de la energía alrededor de tu autocaravana o minicasa. Controla hasta 6 posiciones de CC desde la aplicación o consola EcoFlow.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Panel de distribución inteligente CA/CC',
          desc: 'Con 12 posiciones de CC protegidas por fusible y 6 posiciones de CA protegidas por AFCI, puedes administrar la distribución de la energía alrededor de tu autocaravana o minicasa. Controla hasta 6 posiciones de CC desde la aplicación o consola EcoFlow.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'Entrada principal de CA',
            value: '16A máx., 230V, 3600W'
          }, {
            key: 'Entrada principal de CC',
            value: '70A máx.'
          }, {
            key: 'Salida de CA',
            value: '6 posiciones de CA, 10A máx. cada una'
          }, {
            key: 'Salida de CC',
            value: '12 posiciones de CC protegidas por fusible (6 posiciones controlables a través de la consola y la aplicación del Power Kit)'
          }, {
            key: 'Temperatura de funcionamiento',
            value: 'de - 25 ºC a 60 ºC'
          }, {
            key: 'Tamaño',
            value: '210 x 354 x 98 mm (Alto x Ancho x Profundidad)'
          }, {
            key: 'Peso neto',
            value: '2,6 kg'
          }, {
            key: 'Nivel de protección',
            value: 'IP21'
          }, {
            key: 'Pruebas y certificaciones',
            value: 'CE, UL, FCC, EMC Clase B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'Consola de EcoFlow Power Kits',
        desc: 'Controla, supervisa y consulta tu consumo de energía.',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'Consola de EcoFlow Power Kits',
          desc: 'Controla, supervisa y consulta tu consumo de energía.',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'Pantalla táctil (diagonal)',
            value: '154,21 x 85,92 mm (Ancho x Alto) (7 pulg.)'
          }, {
            key: 'Tensión del suministro de energía',
            value: '12 VCC'
          }, {
            key: 'Temperatura de funcionamiento',
            value: 'de -25 ºC a 60 ºC'
          }, {
            key: 'Tamaño',
            value: 'T113,3 x 204,5 x 22,35 mm (Alto x Ancho x Profundidad)'
          }, {
            key: 'Peso neto',
            value: '450 g'
          }, {
            key: 'Pruebas y certificaciones',
            value: 'CE, UL, FCC, EMC Clase B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_3',
        name: 'Smart Generator',
        desc: 'En casos de emergencia, puedes usar el Smart Generator como fuente de energía auxiliar. Es hasta un 25 % más eficiente que otros generadores, lo que te permite ahorrar combustible y tiempo y reducir los humos.',
        img: '/img/calculators/mm100/combo-generator.jpg',
        imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
        details: {
          title: 'Smart Generator',
          desc: 'En casos de emergencia, puedes usar el Smart Generator como fuente de energía auxiliar. Es hasta un 25 % más eficiente que otros generadores, lo que te permite ahorrar combustible y tiempo y reducir los humos.',
          img: '/img/calculators/mm100/combo-detail-generator.jpg',
          imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
          specParams: [{
            key: 'Peso neto (kg)',
            value: '29,3 kg'
          }, {
            key: 'Tamaño (cm)',
            value: '59,7 x 29,6 x 47,5 cm'
          }, {
            key: 'Tensión nominal',
            value: '230V'
          }, {
            key: 'Tipo',
            value: 'generador inversor'
          }, {
            key: 'Frecuencia',
            value: '50Hz'
          }, {
            key: 'Potencia de salida nominal',
            value: '1800W (máximo de 1900W)'
          }, {
            key: 'Tipo de combustible',
            value: ' Gasolina sin plomo'
          }, {
            key: 'Capacidad del depósito de combustible',
            value: '4 L / 1,06 galones'
          }, {
            key: 'Tiempo de funcionamiento continuo',
            value: '3,5 horas (carga completa)'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_4',
        name: 'Correa de Montaje',
        desc: 'Monta las baterías de manera segura.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7784296120542',
      variantId: '43361967636702',
      name: '2 Paneles solares rígidos de 100 W + 2 pies de montaje solares rígidos',
      discountPrice: 179,
      originalPrice: 229,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2 Paneles solares rígidos de 100 W + 2 pies de montaje solares rígidos',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: 'Potencia nominal',
          value: '100W (+/-5W)'
        }, {
          key: 'Tensión del circuito abierto',
          value: '20,3V'
        }, {
          key: 'Corriente de cortocircuito',
          value: '6,3A'
        }, {
          key: 'Tensión de funcionamiento máxima: 17,1V',
          value: '17,1V'
        }, {
          key: 'Corriente de funcionamiento máxima',
          value: '5,9A'
        }, {
          key: 'Coeficiente de temperatura de potencia nominal',
          value: '-0,39 %/°C'
        }, {
          key: 'Coeficiente de temperatura de tensión de circuito abierto',
          value: '-0,33 %/°C'
        }, {
          key: 'Coeficiente de temperatura de corriente de cortocircuito',
          value: '0,06 %/°C'
        }, {
          key: 'Tensión máxima del sistema',
          value: '600 VCC (UL)'
        }, {
          key: 'Corriente de fusible máxima',
          value: '15A'
        }, {
          key: 'Peso del panel solar',
          value: 'aprox. 6,2 kg (13,7 libras)'
        }, {
          key: 'Tamaño',
          value: '98 x 58,6 x 3 cm'
        }]
      },
      question: {}
    }, {
      productId: '7856793419998',
      variantId: '43593399828702',
      name: '2*400W Rigid Solar Panel + 4*Rigid solar mounting feet',
      discountPrice: 599,
      originalPrice: 799,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 800,
      freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*400W Rigid Solar Panel + 4*Rigid solar mounting feet',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: 'Potencia nominal',
          value: '400W (+/-3 W)'
        }, {
          key: 'Tensión del circuito abierto',
          value: '37.10V'
        }, {
          key: 'Corriente de cortocircuito',
          value: '13.79A'
        }, {
          key: 'Tensión de funcionamiento máxima: 17,1V',
          value: '31.00V'
        }, {
          key: 'Corriente de funcionamiento máxima',
          value: '12.90A'
        }, {
          key: 'Coeficiente de temperatura de potencia nominal',
          value: '-0.38 % /°C'
        }, {
          key: 'Coeficiente de temperatura de tensión de circuito abierto',
          value: '-0.35 % /°C'
        }, {
          key: 'Coeficiente de temperatura de corriente de cortocircuito',
          value: '+0.06 % /°C'
        }, {
          key: 'Tensión máxima del sistema',
          value: '1500V DC'
        }, {
          key: 'Corriente de fusible máxima',
          value: '25A'
        }, {
          key: 'Operating Temp.',
          value: '-20°C - +50°C'
        }, {
          key: 'Peso del panel solar',
          value: 'Approx. 48lbs (21.8Kg)'
        }, {
          key: 'Tamaño',
          value: '1722×1134×35mm'
        }]
      },
      question: {}
    }, {
      productId: '7784277835998',
      variantId: '43361884864734',
      name: '1 Panel solar flexible de 100 W',
      discountPrice: 129,
      originalPrice: 149,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1 Panel solar flexible de 100 W',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: 'Potencia nominal',
          value: '100W (+/-5W)'
        }, {
          key: 'Tensión del circuito abierto',
          value: '20,3V'
        }, {
          key: 'Corriente de cortocircuito',
          value: '6,3A'
        }, {
          key: 'Tensión de funcionamiento máxima: 17,1V',
          value: '17,1V'
        }, {
          key: 'Corriente de funcionamiento máxima',
          value: '5.9 A'
        }, {
          key: 'Coeficiente de temperatura de potencia nominal',
          value: '-0,39 %/°C'
        }, {
          key: 'Coeficiente de temperatura de tensión de circuito abierto',
          value: '-0,33 %/°C'
        }, {
          key: 'Coeficiente de temperatura de corriente de cortocircuito',
          value: '0,06 %/°C'
        }, {
          key: 'Tensión máxima del sistema',
          value: '600 VCC (UL)'
        }, {
          key: 'Corriente de fusible máxima',
          value: '15A'
        }, {
          key: 'Peso del panel solar',
          value: 'aprox. 2,3 kg (5,1 libras)'
        }, {
          key: 'Tamaño',
          value: '1055 x 612 x 25 mm (41,5 x 24,1 x 1,0 pulg.)'
        }]
      },
      question: {}
    }
    // {
    //     productId: '6618094960713',
    //     variantId: '39998021697609',
    //     name: '1 Panel solar rígido de 400 W',
    //     discountPrice: 1199,
    //     originalPrice: 1199,
    //     // discountRate: 0.8,
    //     unit: '€',
    //     number: 0,
    //     capacity: 400,
    //     locale: ['us', 'ca', 'au', 'jp', 'es'], // only for us site
    //     img: '/img/calculators/mm100/solar-400-portable.jpg',
    //     imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //     // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
    //     details: {
    //         title: '1 Panel solar rígido de 400 W',
    //         desc: '',
    //         img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
    //         imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //         specParams: [
    //             { key: 'Potencia nominal', value: '400 W (+/-3 W)' },
    //             { key: 'Tensión del circuito abierto', value: '37,10V' },
    //             { key: 'Corriente de cortocircuito', value: '13,79A' },
    //             { key: 'Tensión de funcionamiento máxima', value: '31,00V' },
    //             { key: 'Corriente de funcionamiento máxima', value: '12,90A' },
    //             { key: 'Coeficiente de temperatura de potencia nominal', value: '-0,38 %/°C' },
    //             { key: 'Coeficiente de temperatura de tensión de circuito abierto', value: '-0,35 %/°C' },
    //             { key: 'Coeficiente de temperatura de corriente de cortocircuito', value: '+0,06%/ºC' },
    //             { key: 'Tensión máxima del sistema', value: '1500 VCC' },
    //             {
    //                 key: 'Corriente de fusible máxima',
    //                 value: '25A',
    //             },
    //             {
    //                 key: 'Temp. de funcionamiento',
    //                 value: 'de -20 °C a +50 °C',
    //             },
    //             {
    //                 key: 'Peso del panel solar',
    //                 value: 'aprox. 21,8 Kg',
    //             },
    //             {
    //                 key: 'Tamaño',
    //                 value: '1722 × 1134 × 35 mm',
    //             },
    //         ],
    //     },
    //     question: {},
    // },
    ],

    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      43223158915294: 'power-2kw.jpg',
      43223158948062: 'bundle-2kw-dp.jpg',
      43223158980830: 'bundle-2kw-all.jpg',
      43223159275742: 'power-4kw.jpg',
      43223159341278: 'bundle-4kw-dp.jpg',
      43223159374046: 'bundle-4kw-all.jpg',
      43223159570654: 'power-5kw.jpg',
      43223159603422: 'bundle-5kw-dp.jpg',
      43223159636190: 'bundle-5kw-all.jpg',
      43223159865566: 'power-10kw.jpg',
      43223159898334: 'bundle-10kw-dp.jpg',
      43223159931102: 'bundle-10kw-all.jpg',
      43223160226014: 'power-15kw.jpg',
      43223160258782: 'bundle-15kw-dp.jpg',
      43223160291550: 'bundle-15kw-all.jpg'
    },
    // solar price discount rate => 2022-06-22: not in use anymore
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7749275320542: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7749275451614: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7749275484382: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7749275549918: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7749275615454: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'Power Hub EcoFlow',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: 'El Power Hub es el corazón de tu Power Kit. Te permite ahorrar un espacio muy valioso en tu furgoneta cámper o casa no conectada a la red eléctrica. El Power Hub realiza el trabajo de dos controladores de carga solar MPPT, un cargador de batería con MPPT, un convertidor reductor de CC-CC y un inversor-cargador, todo ello en una sola unidad, lo que facilita al máximo la configuración.',
      specParams: [{
        key: 'Peso neto',
        value: '14 kg'
      }, {
        key: 'Tamaño',
        value: '30 x 48 x 14 cm (Alto x Ancho x Profundidad)'
      }, {
        key: 'Pruebas y certificaciones',
        value: 'CE, UL, FCC'
      }, {
        key: 'WI-FI',
        value: 'compatible'
      }, {
        key: 'Bluetooth',
        value: 'compatible'
      }, {
        key: 'Frecuencia/salida principal de CA',
        value: 'Onda sinusoidal pura, 3600W (pico de 6000W), 230V, 50Hz / 60Hz'
      }, {
        key: 'Salida principal de CC',
        value: '13,6V / 70A 1000W máx.; 26,4V / 60A, 1500W máx.'
      }, {
        key: 'Entrada principal de CA',
        value: 'Carga rápida X-Stream 3000W máx., 16A máx.'
      }, {
        key: 'Tensión/frecuencia de entrada principal de CA',
        value: '220-240V, 50/60Hz'
      }, {
        key: 'Potencia para carga solar',
        value: '15-150V 30A, 1600W máx.'
      }, {
        key: 'Entrada de carga del alternador',
        value: '13-60V, 60A, 1000W máx.'
      }, {
        key: 'Temperatura de funcionamiento óptima',
        value: 'de 20 a 30 °C'
      }, {
        key: 'Temperatura de descarga',
        value: 'de -25 a 60 °C'
      }, {
        key: 'Temperatura de carga',
        value: 'de -25 a 60 °C'
      }, {
        key: 'Temperatura de almacenamiento',
        value: 'de -25 a 60 °C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: 'El aumento del tiempo de funcionamiento se calculó sobre la base de un promedio del 80 % de la entrada del panel solar y 5 horas de luz solar.'
    },
    // // installations
    // installOptions: [
    //     {
    //         variantId: 0,
    //         i18n: 'self',
    //     },
    //     {
    //         productId: '8454960283995',
    //         variantId: '46803353829723',
    //         i18n: 'expert',
    //         i18n_des: 'pro',
    //     },
    // ],

    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: 'juego de cables + Correa de Montaje'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};